<template>
  <div class="toast-container" aria-live="polite" aria-atomic="true">
    <transition-group name="toast">
      <div
        v-for="item in toasts"
        :key="item.id"
        class="toast-item"
        :class="`toast-${item.type}`"
        role="status"
      >
        <span class="toast-message">{{ item.message }}</span>
        <button type="button" class="toast-close" aria-label="Fechar" @click="dismiss(item.id)">
          ×
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { useToast } from '@/utils/toast';

export default {
  name: 'ToastContainer',
  data() {
    return {
      toasts: useToast().toasts
    };
  },
  methods: {
    dismiss(id) {
      useToast().removeToast(id);
    }
  }
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}

.toast-item {
  min-width: 260px;
  max-width: min(420px, calc(100vw - 32px));
  color: #fff;
  border-radius: 10px;
  padding: 12px 14px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.26);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  pointer-events: auto;
}

.toast-message {
  font-size: 0.92rem;
  line-height: 1.35;
}

.toast-close {
  background: transparent;
  border: none;
  color: inherit;
  opacity: 0.82;
  font-size: 18px;
  cursor: pointer;
}

.toast-close:hover {
  opacity: 1;
}

.toast-info {
  background: #1f2a44;
}

.toast-success {
  background: #187a57;
}

.toast-error {
  background: #9f2d3f;
}

.toast-warning {
  background: #8a5a17;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.2s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

@media (max-width: 767px) {
  .toast-container {
    right: 12px;
    left: 12px;
    top: 12px;
  }

  .toast-item {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }
}
</style>
